import { useReducer, useEffect, useRef } from "react";
import stepChartReducer, { combinedInitialState } from "./reducer";
import { fetchChargerStatus } from "./api";
import ACTIONS from "./actions";

const FETCH_DEBOUNCE_MS = 1000;

async function getChargerStatus(dispatch, chargerId, timeRange) {
  const [startTime, endTime] = timeRange;
  dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_INIT });
  try {
    const chargerStatusData = await fetchChargerStatus(chargerId, startTime?.toISOString(), endTime?.toISOString());
    if (chargerStatusData) {
      const data = chargerStatusData.map(item => ({
        ...item,
        ts: new Date(item.ts).getTime(),
      }));
      data.sort((a, b) => a.ts - b.ts);
      dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_SUCCESS, payload: data });
    } else {
      dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_FAILURE });
    }
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_CHARGER_STATUS_FAILURE });
  }
}

export function useStepChartReducer({ chargerId, timeRange }) {
  const [state, dispatch] = useReducer(stepChartReducer, combinedInitialState);
  const lastFetchRef = useRef(null);

  useEffect(() => {
    if (!chargerId || !timeRange) return;

    const startIso = new Date(timeRange[0]).toISOString();
    const endIso = new Date(timeRange[1]).toISOString();
    const fetchKey = `${chargerId}_${startIso}_${endIso}`;

    const handler = setTimeout(() => {
      if (lastFetchRef.current === fetchKey) return;
      lastFetchRef.current = fetchKey;
      getChargerStatus(dispatch, chargerId, timeRange);
    }, FETCH_DEBOUNCE_MS);

    return () => clearTimeout(handler);
  }, [chargerId, timeRange]);

  // return only the status (step chart) slice to preserve previous hook API
  return {
    status: state.status,
    dispatch,
  };
}

export default useStepChartReducer;
